// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + {"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] + "." + {"189":"92980312714ff467cb62","404":"e702bb1b9271a557aeb4","406":"186c64ac7b95e4eb2b39"}[chunkId] + ".css";
};